
import { httpAuth } from '@/utils/axios';
import { httpNoAuth } from '../utils/axios';
import _ from 'lodash';
import moment from 'moment';
import {weatherCodes} from '@/utils/constants';
import {fetchTeamListData } from '@/actions/match';

let matchRequest = { id: undefined, promise: undefined };

const init = () => ({
  selectedTeamId: undefined,
  currentTeamData: [],
  currentTeam: {
    isHomeTeam: undefined,
    name: undefined,
  },
  match: {
    _id: undefined,
    competition: {
      _id: undefined,
      name: undefined
    },
    venue: {
      _id: undefined,
      name: undefined,
      venueTimezone: undefined,
    },
    round: {
      type: undefined,
      displayName: undefined,
      number: undefined
    },
    dateTime: undefined,
    status: undefined,
    homeTeam: {
      _id: undefined,
      name: undefined,
    },
    awayTeam: {
      _id: undefined,
      name: undefined,
    },
    meta:{
      isBye: undefined,
      isTba: undefined,
      forfeitingTeam:{
        _id: undefined,
        name: undefined,
      }
    },
    scores: {
      homeTeam: 0,
      awayTeam: 0
    },
    setScores: [],
    scoringEvents: [],
    playerMovements: [],
    setScoring: {
      useSetScoring: false,
      setScoringEvent: undefined,
      endSetValue: undefined,
    },
    weather: {},
    matchName: undefined,
    homeTeamList: [],
    awayTeamList: [],
    homeLastFive: [],
    awayLastFive: [],
  }
});

export default {
  namespaced: true,
  state: init(),
  mutations: {
    clear(state) {
      state = Object.assign(state, init());
    },
    setCurrentTeamData(state, payload) {
      state.currentTeamData = payload;
    },
    setCurrentTeam(state, payload) {
      state.currentTeam = payload;
    },
    setMatch(state, payload) {
      state.match = Object.assign(state.match, payload);
      if (state.match.homeTeam) state.selectedTeamId = state.match.homeTeam._id;
      else if (state.match.awayTeam) state.selectedTeamId = state.match.awayTeam._id;
    },
    setSetScores(state, payload) {
      state.match.setScores = Object.assign([], payload);
    },
    setEvents(state, { type, events }) { // scoringEvents || playerMovements
      state.match[type] = events
      // recalculate scores
      state.match.scores.homeTeam = state.match.scoringEvents.filter(e => e.isHomeTeam).reduce((acc, e) => acc + e.value, 0);
      state.match.scores.awayTeam = state.match.scoringEvents.filter(e => !e.isHomeTeam).reduce((acc, e) => acc + e.value, 0);
    },
    setCurrentSetId(state, payload) {
      state.match.currentSetId = payload;
    },
    setStatus(state, payload) {
      state.match.status = payload;
    },
    setScores(state, payload) {
      state.match.scores = Object.assign({}, payload);
    },
    setSelectedTeamId(state, payload) {
      state.selectedTeamId = payload;
    },
    setWeather(state, payload) {
      state.match.weather = payload;
    },
    setForfeitingTeam(state, payload) {
      state.match.meta.forfeitingTeam = payload;
    },
    setHomeTeamList(state, payload) {
      state.match.homeTeamList = payload;
    },
    setAwayTeamList(state, payload) {
      state.match.awayTeamList = payload;
    },
  },
  actions: {
    matchResponse(context, { id }) {
      if (matchRequest.promise && matchRequest.id === String(id)) return matchRequest.promise;
      return httpAuth.get(`assemble/api/v1/live/matches/${id}`);
    },
    async setup({ commit, state }, { id }) {
      const request = httpAuth.get(`assemble/api/v1/live/matches/${id}`);
      matchRequest = { id: String(id), promise: request };
      // dedupes in-flight requests only, cleared once settled so nothing stale is served
      request
        .finally(() => {
          if (matchRequest.promise === request) matchRequest = { id: undefined, promise: undefined };
        })
        .catch(() => {});
      request
        .then(async res => {
          console.log({
            res
          });
          commit('setMatch', res.data.data);
          // fetch weather
          const baseUrl = 'https://api.tomorrow.io/v4/timelines?';

          const address = _.get(res.data.data, 'venue.address');
          const startDate = _.get(res.data.data, 'dateTime');

          if (!address || !startDate) {
            return {};
          } else {
            const { lat, lng } = address;
            const query = {
              location: [lat, lng],
              fields: ['weatherCode', 'temperature'],
              timesteps: '1d',
              units: 'metric',
              apikey: process.env.VUE_APP_WEATHER_API_KEY,
              startTime: moment(startDate).startOf('day').toISOString(),
              endTime: moment(startDate).add(2, 'days').toISOString()
            };
            const queryString = new URLSearchParams(query).toString();
            const url = `${baseUrl}${queryString}`;
            // eslint-disable-next-line no-await-in-loop
            await fetch(url).then((r) => r.json()).then((res) => {
              const wData = _.get(res, 'data.timelines[0].intervals[1].values', {});
              // const wData = {
              //   weatherCode: 1000,
              //   temperature: 20.44
              // };
              if (wData.weatherCode) {
                wData.base = _.find(weatherCodes, (c) => c.value === wData.weatherCode) || {};
              }
              commit('setWeather', wData);
            }).catch(() => {
            });
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    async addEvent({ commit, state }, { type, event }) {
      httpAuth
        .post(`/assemble/api/v1/live/matches/${state.match._id}/${type}`, event)
        .then((res) => { 
          const response = res.data.data;
          const eventType = type === 'scorings' ? 'scoringEvents' : 'playerMovements';
          const events = state.match[eventType];
          commit('setEvents', { type: eventType, events: [...events, event]});
          if (response) commit('setScores', response.scores)
        })
        .catch((e) => {
          throw new Error(e.response.data);
        })
    }
  },
  getters: {
    currentTeamData(state) {
      return state.currentTeamData;
    },
    currentTeam(state) {
      return state.currentTeam;
    },
    matchDetails(state) {
      return state.match;
    },
    setScores(state) {
      return state.match.setScores
    },
    homeScore(state) {
      // return state.match.scoringEvents.reduce((acc, current) => current.isHomeTeam 
      //   ? acc += current.value 
      //   : acc
      // , 0)

      return state.match.scores.homeTeam;
    },
    awayScore(state) {
      // return state.match.scoringEvents.reduce((acc, current) => !current.isHomeTeam 
      //   ? acc += current.value 
      //   : acc
      // , 0)
      return state.match.scores.awayTeam;
    },
    homeTeamList(state) {
      return state.match.homeTeamList;
    },
    awayTeamList(state) {
      return state.match.awayTeamList;
    },
    homeLastFive(state) {
      return state.match.homeLastFive;
    },
    awayLastFive(state) {
      return state.match.awayLastFive;
    },
    homeTeam(state) {
      return state.match.homeTeam;
    },
    awayTeam(state) {
      return state.match.awayTeam;
    },
    gameStatus(state) {
      return state.match.status;
    },
    matchId(state) {
      return state.match._id;
    },
    selectedTeamId(state) {
      return state.selectedTeamId;
    },
    currentTeamName(state) {
      return state.match.homeTeam && state.match.homeTeam._id === state.selectedTeamId
        ? state.match.homeTeam.name
        : state.match.awayTeam && state.match.awayTeam._id === state.selectedTeamId
          ? state.match.awayTeam.name
          : '';
    },
    matchScorings(state) {
      return state.match.scoringEvents
    },
    matchMovements(state) {
      return state.match.playerMovements
    },
    matchEvents(state) {
      return state.match.scoringEvents
        .map(e => ({...e, eventType: 'scoring'}))
        .concat(state.match.playerMovements.map(e => ({...e, eventType: 'movement'})))
    },
    competition(state) {
      return state.match.competition;
    }
  },
};
  